import { useQuery } from '@tanstack/react-query';
import { configuratorService } from '@ui/services';

const getConfigurationsQuery = (siteCode: string) => {
  return {
    queryKey: ['configuration', 'list'],
    queryFn: () => configuratorService.getConfigurations(siteCode),
  };
};

export function useGetConfigurations(siteCode: string) {
  return useQuery({
    ...getConfigurationsQuery(siteCode),
  });
}
